<template>
  <div style="margin-top: 10px">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>野兽币钻石发放明细</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="奖励类型" prop="type">
          <el-select
            v-model.number="queryParams.type"
            placeholder="请选择类型"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          >
            <el-option
              v-for="(item, index) in rewardType"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="table"
        border
        :data="getTableData[0]"
        style="width: 100%;"
      >
        <template v-for="(item, index) in getTableData[1]">
          <el-table-column
            :key="index"
            :label="item.unit ? `${item.label}（${item.unit}）` : item.label"
            :prop="item.value"
            :header-align="item.headerAlign || 'center'"
            :min-width="item.minWidth || 120"
            :align="item.align || 'center'"
          >
            <template slot-scope="scope">
              {{ tableFormatter(item.value, scope.row) }}
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-card>

    <el-card>
      <grantEchart ref="grantEchart" />
    </el-card>

  </div>
</template>

<script>
import { getGrantStat } from '@/api/statistics/user_remain'
import grantEchart from '@/views/config/spins-consume/compents/grant-echart.vue'
export default {
  name: 'GrantStat',
  components: {
    grantEchart
  },
  data() {
    return {
      headerList: [],
      tableData: [],
      rewardType: [
        { label: '野兽币', value: 65 },
        { label: '钻石', value: 22 }
      ],
      maxLevel: 0,
      queryParams: {
        type: 65,
        startDate: '',
        endDate: '',
        level: 0
      }
    }
  },
  computed: {
    getTableData() {
      return this.fotmatterTableData(this.tableData, this.headerList)
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    exportData() {
      this.queryParams.level = -1
      this.getTables()
    },
    handleQuery() {
      this.queryParams.level = 0
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      getGrantStat(this.queryParams).then(res => {
        if (this.queryParams.level === -1) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          return
        }
        this.tableData = []
        const data = res.data.data.data

        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        if (data.length <= 0) {
          this.headerList = []
          return
        } else {
          this.headerList.push({
            label: '等级',
            value: 'date',
            unit: '',
            headerAlign: 'center',
            minWidth: '110',
            align: 'center'
          })
        }
        this.maxLevel = res.data.data.max_level
        const tableData = {
          date: ''
        }
        for (let i = 1; i <= this.maxLevel; i++) {
          const header = {
            label: '等级' + i,
            value: 'level' + i,
            unit: '',
            headerAlign: 'center',
            minWidth: '80',
            align: 'center'
          }
          tableData['level' + i] = 0
          this.headerList.push(header)
        }
        for (const i in data) {
          const val = data[i]
          if (this.queryParams.type === 65) {
            for (const k in val.level_data) {
              if (val.level_data[k] > 0) {
                const num = (val.level_data[k] / 10000).toFixed(2)
                data[i].level_data[k] = parseFloat(num)
              }
            }
          }
          const copyTable = Object.assign({}, tableData)
          copyTable['date'] = val.date
          this.tableData.push(copyTable)
        }

        for (const i in data) {
          const val = data[i]
          for (const k in this.tableData) {
            const tdata = this.tableData[k]
            if (val.date === tdata.date) {
              for (const l in val.level_data) {
                this.tableData[k]['level' + l] = val.level_data[l]
              }
            }
          }
        }

        this.$refs.grantEchart.init(this.queryParams.type, data, this.maxLevel)
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        console.log('column', column.property)
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 元'
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    fotmatterTableData(data, header) {
      const enddata = []
      const endheader = []
      header.forEach((item, index) => {
        if (index === 0) {
          endheader.push({
            label: header[index].label,
            value: 'mainIndex',
            unit: header[index].unit,
            headerAlign: header[index].headerAlign,
            minWidth: header[index].minWidth,
            align: header[index].align
          })
          data.forEach((ele, idx) => {
            endheader.push({
              label: ele[header[index].value],
              value: `type${idx}`
            })
          })
        } else {
          const obj = {
            mainIndex: header[index].label,
            unit: header[index].unit
          }
          data.forEach((ele, ind) => {
            obj[`type${ind}`] = ele[header[index].value]
          })
          enddata.push(obj)
        }
      })
      return [enddata, endheader]
    },
    // 列表格式化
    tableFormatter(prop, row) {
      if (row[prop] || row[prop] === 0) {
        if (prop === 'mainIndex') {
          if (row.unit) {
            return `${row[prop]}（${row.unit}）`
          }
          return row[prop]
        }
        return row[prop]
      }
      return '--'
    }
  }
}
</script>

<style scoped>

</style>
